export const deleteWalletRoutes = [
  // {
  //   path: 'manage/deleteWalletStart',
  //   name: 'delete_wallet_start',
  //   component: () =>
  //     import(
  //       '@/views/dashboard/wallet_manage/delete-wallet/DeleteWalletStart.vue'
  //     ),
  // },
  {
    path: 'wallet/:walletId/deleteWalletExec',
    name: 'delete_wallet_Exec',
    component: () =>
      import(
        '@/views/dashboard/wallet_manage/delete-wallet/DeleteWalletExec.vue'
      ),
    meta: {
      PageTitle: 'wallet_manage.delete_wallet.title',
    },
  },
  {
    path: 'wallet/:walletId/deleteWalletComplete/:label',
    name: 'delete_wallet_complete',
    component: () =>
      import(
        '@/views/dashboard/wallet_manage/delete-wallet/DeleteWalletComplete.vue'
      ),
    meta: {
      PageTitle: 'wallet_manage.delete_wallet.title',
    },
  },
]
